module.exports = __webpack_public_path__ + "media/country_flags/cg-d232c733.png";